<template>
  <div class="card mb-5 mb-xl-10">
    <BlockUI :loading="block" />
    <ConfirmPopup></ConfirmPopup>
    <!--begin::Card header-->
    <div class="border-bottom">
      <!--begin::Card title-->
      <div class="row ps-8 pe-8 pt-3 pb-3 align-items-center">
        <div class="col-lg-5">
          <h3 class="fw-bolder m-0 fs-4 text-gray-800 m-3">
            {{ translate("Locations") }}
          </h3>
        </div>
        <div class="col-lg-3"></div>
        <div class="col-lg-4">
          <div class="row">
            <FilterInput
              :PlaceHolder="
                translate('project_detail_location_input_seacrh_placeholder')
              "
              :searchId="0"
              :filterList="filterList"
              @onFilterSearch="Search"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-between p-8 pt-6 pb-6 border-bottom"
      style="background: #fbfbfb"
    >
      <div
        v-show="CLocationList.length > 0"
        class="form-check form-check-custom form-check-solid"
        style="margin-left: 2.3rem !important"
      >
        <input
          ref="checkAll"
          class="form-check-input"
          type="checkbox"
          @change="selectAll($event)"
          id="check-all"
        />
        <label
          class="form-check-label text-primary fw-bolder fs-7"
          style="margin-left: 1.3rem !important"
          for="check-all"
        >
          {{ translate("Select_All") }}
        </label>
      </div>
      <button
        v-show="CLocationList.filter((i) => i.checked === true).length > 0"
        @click="deleteCLocation()"
        type="button"
        class="btn bg-white bg-hover-secondary btn-sm border position-relative ms-2 text-gray-700"
      >
        {{ translate("project_detail_location_button_remove_locations")
        }}<span
          class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger"
          >{{ CLocationList.filter((i) => i.checked === true).length }}</span
        >
      </button>
    </div>
    <div class="card-body pt-6 pb-0">
      <!--begin::Item-->
      <div
        class="d-flex align-items-center mb-1 border rounded p-2"
        v-for="(CLocationItem, index) in CLocationList"
        :key="index"
      >
        <!--begin::Bullet-->
        <span
          class="bullet bullet-vertical h-40px"
          :class="`bg-primary`"
        ></span>
        <!--end::Bullet-->

        <!--begin::Checkbox-->
        <div class="form-check form-check-custom form-check-solid mx-5">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            v-model="CLocationItem.checked"
          />
        </div>
        <!--end::Checkbox-->

        <!--begin::Description-->
        <div class="flex-grow-1">
          <div class="d-flex flex-column position-relative w-100">
            <label
              class="form-check-label col-form-label fw-bold p-0 mt-2"
              for="check-remember"
              style="margin-bottom: 15px"
            >
              <span
                v-show="
                  CLocationList[index].Code !== null &&
                  CLocationList[index].Code !== ''
                "
                >{{ CLocationList[index].Code }} - </span
              ><span>{{ CLocationList[index].Name }}</span>
            </label>
            <label
              class="form-check-label col-form-label fw-bold fs-7 p-0 text-gray-500"
              for="check-remember"
              style="position: absolute; margin-top: 20px"
            >
              {{ CLocationList[index].CountryName }} -
              {{ CLocationList[index].CityName }}
            </label>
          </div>
        </div>
        <!--end::Description-->

        <span
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#add-location-modal"
          class="btn fs-7 fw-bolder bg-light-primary btn-sm text-primary p-1 ps-3 pe-3 me-2 d-flex"
          @click="propsUpdate(CLocationList[index].Id)"
        >
          {{ translate("customer_detail_button_edit") }}
        </span>

        <span
          class="badge fs-7 fw-bolder badge-white border"
          style="cursor: pointer"
          @click="deleteCLocation(CLocationList[index])"
          >{{ translate("Delete") }}</span
        >
      </div>
    </div>

    <div class="row ps-8 pe-8 pt-5 pb-5 align-items-center">
      <div class="col-lg-8">
        <Pagination @onPage="onPage" :TotalData="records" />
      </div>
      <div class="col-lg-2"></div>
      <div class="col-lg-2">
        <div class="row align-items-center justify-content-end w-100 mx-0 m-2">
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#add-location-modal"
            class="btn btn-primary align-self-center btn-sm ps-2 pe-2 mt-2 mb-2"
            @click="customerProfilEdit"
          >
            {{ translate("location_list_add_button") }}
          </button>
        </div>
      </div>
    </div>
    <AddLocation
      :locationId="locationId"
      :customerId="customerId"
      @closeModal="closeModal"
      :customer="customer"
    />
  </div>
</template>

<script setup>
import AddLocation from "@/components/Admin/Customer-Modal/AddLocation.vue";
import { ref, onActivated, reactive, computed, onMounted, inject } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

import { useConfirm } from "primevue/useconfirm";

const confirm = useConfirm();
const lazyParams = ref({});
const customerId = parseInt(inject("customerId"));
const store = useStore();
const customer = inject("customer");
const block = ref(true);
// Filter

const filterList = ref(["name", "code", "countryName", "cityName"]);

//Location Update
const locationId = ref(0);

const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
const closeModal = () => {
  locationId.value = 0;
};

const propsUpdate = (Id) => {
  locationId.value = Id;
};

const getAllProjectLocations = () => {
  lazyParams.value.customerId = customerId;
  store
    .dispatch("LocationModule/GET_ALL_LOCATION", lazyParams.value)
    .finally(() => (block.value = false));
};

onMounted(() => {
  lazyParams.value = {
    page: 1,
    pageSize: 10,
    customerId: 0,
    name: null,
    code: null,
    countryName: null,
    cityName: null,
  };
  getAllProjectLocations();
});

const CLocationList = computed(
  () => store.getters["LocationModule/_getLocationList"]
);
const records = computed(
  () => store.getters["LocationModule/_getTotalRecords"]
);

const Search = (filter) => {
  let deger = null;
  if (filter !== null) {
    deger = Object.keys(filter)[0];
  }
  Object.keys(lazyParams.value).forEach((i) => {
    if (i === deger) {
      lazyParams.value[i] = filter[deger];
    } else {
      if (i !== "page" && i !== "pageSize") lazyParams.value[i] = null;
    }
  });

  getAllProjectLocations(lazyParams.value);
};

const selectAll = (event) => {
  CLocationList.value.forEach((item) => (item.checked = event.target.checked));
};
const deleteCLocation = (Item) => {
  let obj = [];
  let list = [];
  if (Item !== undefined) {
    obj.push(Item.Id);
    list.push(obj);
    list.push(lazyParams.value);
  } else {
    let value = CLocationList.value.filter((i) => i.checked === true);
    value.forEach((item) => {
      obj.push(item.Id);
    });
    list.push(obj);
    list.push(lazyParams.value);
  }

  let message = ref("");
  if (obj.length > 1) {
    message.value = translate("confirm_message_locations");
  } else {
    message.value = translate("customer_location_confirm_message");
  }
  confirm.require({
    target: event.currentTarget,
    message: message.value,
    icon: "bi bi-exclamation-lg",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      store.dispatch("LocationModule/DELETE_LOCATION", list);
    },
    reject: () => {
      return;
    },
  });
};

const onPage = (e) => {
  lazyParams.value.page = e.step.value;
  lazyParams.value.pageSize = e.pageSize.value;
  getAllProjectLocations(lazyParams.value);
};
// Filter End
</script>

<style scoped></style>
